/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type GetAvailabilityZocdocAvailabilityGetParams = {
  provider_location_id: string;
  visit_reason_id: string;
  start_date?: string | null;
  end_date?: string | null;
};
